import { useState } from 'react';

import { maskTaxId } from '../lib/mask-tax-id';

type Props = {
    taxId: string;
};

// Masked at rest, full value while hovered or keyboard-focused, reverting once neither holds.
// A `<button>` rather than a `tabIndex`-ed `<span>` needs no ARIA role to be keyboard-focusable.
export function MaskedTaxId({ taxId }: Props) {
    const [isHovered, setIsHovered] = useState(false);
    const [isFocused, setIsFocused] = useState(false);

    return (
        <button
            type="button"
            className="inline border-0 bg-transparent p-0 text-inherit"
            onPointerEnter={() => setIsHovered(true)}
            onPointerLeave={() => setIsHovered(false)}
            onFocus={() => setIsFocused(true)}
            onBlur={() => setIsFocused(false)}
        >
            {isHovered || isFocused ? taxId : maskTaxId(taxId)}
        </button>
    );
}
